import { PromotionTypeEnum } from "../enums/promotionType";

export const convertPromotionTypeToText=(value:string):string=>{
    if(value===PromotionTypeEnum.buy_x_get_x){
        return "ໍຊື້ 1 ແຖມ 1";
    }
    else if(value===PromotionTypeEnum.buy_x_get_ds){
        return "ຫຼຸດລາຄາ";
    }
    else {
        return value;
    }
}